<div class="sp-width__full sp-row__space sp-wrap">
  <div class="sp-row__align">
    <app-shared-store-logo
      size="s"
      [current_store_logo]="store?.logo_url"></app-shared-store-logo>
    <span class="sp-color__primary sp-margin__left"> {{ store?.name }} </span>
  </div>

  <div class="sp-row__align">
    <span class="sp-color__primary"> {{ store?.created_at | date : 'short' }} </span>
  </div>
  <hr
    class="sp-width__full sp-stroke sp-stroke__dashed-dark"
    style="margin-top: 4px" />
</div>
